import React from 'react'
import TargetsContainer from "../../containers/configuration/Targets"

const Targets = () => {
  return <TargetsContainer/>
}

export default Targets
